import { useEffect, useRef, useState } from "react";
import img1 from '../../../../Assets/aboutSection_1.png'
import img2 from '../../../../Assets/aboutSection_2.png'
import img3 from '../../../../Assets/aboutSection_3.png'
import * as S from './styles'

const CARDS = [
  {
    step: "1º Passo",
    title: "O Problema",
    body:
      "Empresas com ótimas ideias esbarram em barreiras: sistemas que não conversam, operações travadas, dados dispersos e a insegurança em inovar.",
    tags: ["Falta de Mão de Obra", "Escalabilidade", "Impedimentos técnicos"],
    img: img1,
  },
  {
    step: "2º Passo",
    title: "A Parceria",
    body:
      "É aí que a Bindflow entra. Escutamos, entendemos e criamos soluções digitais sob medida; seja para um MVP ágil ou um ecossistema de dados robusto.",
    tags: ["Levantamento de Requisitos", "MVP", "Sob Medida"],
    img: img2,
  },
  {
    step: "3º Passo",
    title: "A Transformação",
    body:
      "Eficiência, escalabilidade e inovação contínua. Você conquista processos mais enxutos, dados confiáveis para decidir e segurança para crescer.",
    tags: ["Escalabilidade", "Segurança", "Confiança"],
    img: img3,
  },
];

export const AboutSection = () => {
  const [active, setActive] = useState(0);
  const cardRefs = useRef([]);
  const sectionRef = useRef(null); // para o parallax

  // Descobre o card ativo enquanto a pessoa rola
  useEffect(() => {
    const isDesktop = () => window.matchMedia("(min-width:1024px)").matches;
    if (!isDesktop()) return;

    const opts = { root: null, threshold: 0.01, rootMargin: "-40% 0px -50% 0px" };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          const idx = Number(e.target.getAttribute("data-idx"));
          setActive(idx);
        }
      });
    }, opts);

    cardRefs.current.forEach((el) => el && io.observe(el));
    return () => io.disconnect();
  }, []);

  // Parallax leve na coluna sticky (não altera tamanho)
  useEffect(() => {
    const sec = sectionRef.current;
    if (!sec) return;

    const onScroll = () => {
      const r = sec.getBoundingClientRect();
      const visible = Math.min(
        Math.max(0, (window.innerHeight - r.top) / (r.height + window.innerHeight)),
        1
      );
      const offset = (visible - 0.5) * 40; // -20px a 20px
      sec.style.setProperty("--parallax", `${offset}px`);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <S.Wrapper ref={sectionRef}>
      <S.Container>
        <S.CardsCol>
          <S.Header>
            <h3>Do conceito à <br className="first" />execução, transformamos barreiras em<br />oportunidades.</h3>
            <p>Porque para nós, cada desafio é o ponto <br className="first" />de partida para uma nova conquista.</p>
          </S.Header>

          {CARDS.map((c, i) => (
            <S.Card
              key={i}
              ref={(el) => (cardRefs.current[i] = el)}
              data-idx={i}
              data-active={i === active ? "true" : "false"}
            >
              <div className="module">
                <div className='colors blue'></div>
                <div className='colors pink'></div>

                <S.StepPill>{c.step}</S.StepPill>

                <S.CardTitle className={i === 2 ? "accent" : ""}>
                  {c.title}
                </S.CardTitle>

                <S.CardBody>{c.body}</S.CardBody>

                <S.Tags>
                  {c.tags.map((t, k) => (
                    <S.Tag key={k}>{t}</S.Tag>
                  ))}
                </S.Tags>
              </div>
            </S.Card>
          ))}
        </S.CardsCol>

        <S.Sticky>
          <S.ImageFrame>
            {CARDS.map((c, i) => (
              <S.SwapImage
                key={i}
                src={c.img}
                alt={c.title}
                className={active === i ? "is-active" : ""}
              />
            ))}
          </S.ImageFrame>
        </S.Sticky>
      </S.Container>
    </S.Wrapper>
  );
}
